<template>
  <div>
    <a @click="dialog = true">Password vergessen</a>
    <v-dialog
      v-model="dialog"
      persistent
      width="500px"
    >
      <v-card-title primary-title>
        <h3 class="headline mb-0">
          Password zurücksetzen
        </h3>
      </v-card-title>
      <v-form v-model="valid">
        <v-card-text>
          <v-text-field
            v-model.trim="email"
            label="E-Mail"
            placeholder="Max.Mustermann@spicetech.de"
            :rules="emailRules"
          />
        </v-card-text>
        <v-card-actions>
          <v-row
            max-width="auto"
            justify="end"
            style="margin: 0; gap: 10px;"
          >
            <v-btn
              text
              @click="dialog = false"
            >
              Abbrechen
            </v-btn>
            <v-btn
              color="primary"
              :disabled="!valid"
              :loading="loading"
              @click="resetPassword()"
            >
              Zurücksetzen
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: 'ResetPasswordDialog',
  data: () => ({
    dialog: false,
    valid: false,
    emailRules: [
      v => !!v || 'E-Mail ist erforderlich',
      v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'die E-Mail muss gültig sein'
    ],
    email: '',
    loading: false
  }),
  methods: {
    ...mapActions(["showSnackbar"]),
    resetPassword(){
      this.loading = true;
      $api.post("/user/resetpassword", {email: this.email})
        .then(() => {
          this.showSnackbar(
            {
              text: "Eine E-Mail mit Anweisungen zum Zurücksetzen des Passwortes wurde an "
                    + this.email
                    + " gesendet.",
              timeout: "5000",
              type: "success"
            }
          );
          this.email = "";
          this.dialog = false;
          this.loading = false;
        });
    }
  }
}
</script>

<style>

</style>